import React from 'react';
import './PopupForm.css';

const PopupForm = ({ children }) => {
  return (
    <div className="popup">
      <div className="popup-content">
        {children}
      </div>
    </div>
  );
};

export default PopupForm;
